import React, { useState } from 'react';
import '../../styles/Login.css';
import { loginUser } from '../../services/api';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await loginUser({ username, password });
      if (response.token) {
        localStorage.setItem('token', response.token); // Store token for auth
        onLogin();
      } else {
        setError('Invalid credentials');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
    }
  };

  return (
    <div className="sp-login-container">
      <h2 className="sp-login-title">Client Portal Login</h2>
      {error && <p className="sp-login-error">{error}</p>}
      <form className="sp-login-form" onSubmit={handleSubmit}>
        <input
          className="sp-login-input"
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          className="sp-login-input"
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <button className="sp-login-btn" type="submit">Login</button>
        {/* <a href="/" className="sp-login-forgot">Forgot Password?</a> */}
      </form>
    </div>
  );
}

export default Login;